import { Dispatch, SetStateAction, createContext, useContext } from 'react';
import { UserDetails } from 'api/usersApi';

interface UserContextProp {
  user: UserDetails | null;
  setUser: Dispatch<SetStateAction<UserDetails | null>>;
  username: string;
  setUsername: Dispatch<SetStateAction<string>>;
  userList: UserDetails[];
  setUserList: Dispatch<SetStateAction<UserDetails[]>>;
}

const UserContext = createContext<UserContextProp>({
  user: null,
  setUser: () => {},
  username: '',
  setUsername: () => {},
  userList: [],
  setUserList: () => {},
});

export const useUserContext = () => useContext(UserContext);

export default UserContext;
